import FrenchPage from '../components/lifecycle/FrenchPage';
import ContactHeadFR from '../components/contact/ContactHeadFR';
import Contact from './Contact'

export default function ContactFR() {
  return (
    <>
      <FrenchPage />
      <ContactHeadFR />
      <Contact />
    </>
  );
}